import { get } from 'lodash-es';

export const getEmbeddedSnippetId = (data): string =>
    get(data, 'embed.id') || get(data, 'contentAttributes.id');
